module.exports = __webpack_public_path__ + "img/20230109172656.7106efa0.jpg";